import { useRef, useState, useEffect } from "react";
import { TFilters } from "../../../../../../../components/TableDataGridV2/types";
import { useFormContext } from "react-hook-form";
import { Alert, Button, Stack, Typography } from "@mui/material";
import PreFiltros from "../../../PreFiltrosListagens";
import DisplayDadosClienteFormulario from "../../../../MIAnaliseDeCredito/DisplayDadosClienteFormulario";
import { headCellsRecebimento } from "../../../dataGridConfig";
import {
  TableDataGridRef,
  TableDataGridV2,
} from "../../../../../../../components/TableDataGridV2";
import { enqueueSnackbar } from "notistack";
import { IDataListaTitulosReceber } from "../../../../../../../types/api/financeiro/pesquisar-titulos-receber";
import { formatarValorMonetario } from "../../../../../../../helpers/masks";

export default function Step01({
  handleChangeSelected,
}: Step01Props) {

  const tableRef = useRef<TableDataGridRef>(null);
  const { getValues, setValue } = useFormContext();
  const [selecaoInfo, setSelecaoInfo] = useState({ total: 0, quantidade: 0 });

  const preFilter = getValues("preFilterStep");
  const [preFilters, setPreFilters] = useState<TFilters>({});

  const isFuncaoTroca = preFilters?.funcao_contem?.flg_troca_funcao === "S";

  useEffect(() => {
    setValue("funcaoTroca", isFuncaoTroca);
  }, [isFuncaoTroca, setValue]);

  const handleSelectionChange = (selectedRows: IDataListaTitulosReceber[]) => {
    setSelecaoInfo({
      total: selectedRows.reduce((acc, row) => acc + (row.saldo_principal || 0), 0),
      quantidade: selectedRows.length
    });
  };

  //funcoes manipuladoras
  const handleNext = () => {
    if (tableRef.current) {
      const selectedRows = tableRef.current.getSelectedRows();
      if (selectedRows.length === 0) {
        enqueueSnackbar("Por favor, selecione pelo menos um título.", {
          variant: "warning",
        });
        return;
      }

      handleChangeSelected(selectedRows);
      const nextStep = getValues("funcoesAux.onNext");
      nextStep();
    }
  };
  //

  return (
    <>
      {preFilter && (
        <PreFiltros
          filtros={preFilters}
          onSubmitFilters={(values) => {
            setPreFilters(values);
            setValue("preFilterStep", false);
          }}
        />
      )}

      {!preFilter && (
        <>
          {isFuncaoTroca && (
            <Alert variant="filled" severity="warning" sx={{ mb: 2 }}>
              <Typography variant="body2">
                Função de troca selecionada: {preFilters.funcao_contem?.nome}
              </Typography>
            </Alert>
          )}

          {preFilters?.tipo_publico_pesquisar &&
            preFilters?.codigo_publico_pesquisar && (
              <DisplayDadosClienteFormulario
                tipoDado="param"
                tipo={preFilters.tipo_publico_pesquisar}
                codigo={preFilters.codigo_publico_pesquisar}
              />
            )}

          <TableDataGridV2
            ref={tableRef}
            urlParams
            columns={headCellsRecebimento}
            url="/financeiro/contas-receber/pesquisar-titulos-receber"
            queryKey="listar-todos-titulos-receber"
            enableSelection={true}
            pagination="server"
            queryParams={{
              data_recebimento_is_null: true,
              provisionado_diferente: "S",
              funcao_troca: isFuncaoTroca,
            }}
            preFilledFilters={preFilters}
            handleUpdatePreFilters={(value) => setPreFilters(value)}
            selectedFields={[
              "id",
              "tipo_publico",
              "codigo_publico",
              "boleto",
              "data_emissao",
              "saldo_principal"
            ]}
            onSelectionChange={handleSelectionChange}
          />

          <Stack direction="row" justifyContent="space-between" alignItems="flex-end" mt={1}>
            <Stack>
              <Typography variant="subtitle2">
                <b>Quantidade:</b> {selecaoInfo.quantidade}
              </Typography>
              <Typography variant="subtitle2">
                <b>Total:</b> {formatarValorMonetario(selecaoInfo.total)}
              </Typography>
            </Stack>
            <Button variant="contained" onClick={handleNext}>
              Avançar
            </Button>
          </Stack>
        </>
      )}
    </>
  );
}

export interface SelectedFieldsType {
  id: string;
  tipo_publico: string;
  codigo_publico: string;
  boleto: string;
}

interface Step01Props {
  handleChangeSelected: (value: string[]) => void;
}

export type PesquisarTitulosAReceber = {
  codigo_publico: number;
  comprador: string;
  data_emissao: string;
  data_pagamento: string;
  data_vencimento: string;
  departamento: string;
  departamento_id: number;
  funcao: string;
  funcao_id: number;
  historico: string;
  loja_id: number;
  nome_publico: string;
  numero_documento: number;
  numero_nf: number;
  sequencia_documento: string;
  serie_nf: number;
  tipo_documento: string;
  tipo_publico: string;
  id: string;
  valor_original: number;
  saldo_principal: number;
  saldo_simulado: number;
};
